var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { Loader } from '@googlemaps/js-api-loader';
import analytics from '../../analytics/analytics';
import { GOOGLE_MAP_API_KEY, PRICELINE_MAP_ID } from '../../constants/googleMapConst';
import { createMapAdvancedMarkerElement } from './createMapAdvancedMarkerElement';
export const initMapManager = () => {
  let map = null;
  let loader = null;
  let mapMarkerLib = null;
  let mapCoreLib = null;
  const callbacks = [];
  return {
    initloader: () => {
      var _a, _b;
      if (typeof window !== 'undefined' && typeof ((_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary) === 'function') {
        loader = window.google.maps;
      }
      if (!loader) {
        loader = new Loader({
          apiKey: GOOGLE_MAP_API_KEY,
          version: 'weekly'
        });
      }
      return loader;
    },
    setMap: () => __awaiter(void 0, void 0, void 0, function* () {
      const {
        Map
      } = yield loader.importLibrary('maps');
      map = new Map(document.getElementById('PENNY-SEARCH-GOOGLE-MAP'), {
        zoomControl: true,
        fullscreenControl: false,
        cameraControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        center: {
          lat: 40.7128,
          lng: -74.006
        },
        zoom: 8,
        mapId: PRICELINE_MAP_ID // The priceline mapId
      });
      mapMarkerLib = yield loader.importLibrary('marker');
      mapCoreLib = yield loader.importLibrary('core');
    }),
    addCallback: function (cb) {
      callbacks.push(cb);
      // If map is already initialized, call the callback immediately
      if (map) {
        this.fireCallbacks();
      }
    },
    fireCallbacks: function fireCallbacks() {
      while (callbacks.length > 0) {
        const cb = callbacks.shift();
        const options = {
          map,
          loader
        };
        cb(options);
      }
    },
    fitBoundsOnCurrentMap: function fitBoundsOnCurrentMap(listOfPins) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!map || !loader || !Array.isArray(listOfPins) || listOfPins.length === 0) return;
        try {
          const {
            LatLngBounds
          } = mapCoreLib;
          const bounds = new LatLngBounds();
          listOfPins.forEach(pin => {
            const latLng = {
              lat: Number(pin.lat),
              lng: Number(pin.lng)
            };
            if (!Number.isNaN(latLng.lat) && !Number.isNaN(latLng.lng)) {
              bounds.extend(latLng);
            }
          });
          const manager = this;
          if (listOfPins.length === 1) {
            setTimeout(() => {
              manager.createAdvancedMarker(listOfPins[0]);
            }, 200);
            map.setCenter(bounds.getCenter());
            map.setZoom(17);
          } else {
            setTimeout(() => {
              listOfPins.forEach(pin => {
                manager.createAdvancedMarker(pin);
              });
            }, 200);
            map.fitBounds(bounds);
          }
        } catch (e) {
          analytics.logError({
            loggedFrom: 'initMapManager:fitBoundsOnCurrentMap',
            message: 'Failed to call fitBounds on map',
            error: e.message
          });
        }
      });
    },
    createAdvancedMarker: function createAdvancedMarker(options) {
      const {
        AdvancedMarkerElement
      } = mapMarkerLib;
      createMapAdvancedMarkerElement({
        gMap: map,
        AdvancedMarkerElement,
        pinDetails: options
      });
    }
  };
};
export const mapManager = initMapManager();